import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module')
      .then(m => m.DashboardModule)
  },
  {
    path: 'trm',
    loadChildren: () => import('./trm/trm.module')
      .then(m => m.TrmModule)
  },
  {
    path: 'company', loadChildren: () => import('./company/company.module')
      .then(m => m.CompanyModule)
  },

  { path: 'hotels', loadChildren: () => import('./hotel-static-content/hotel-static-content.module').then(m => m.HotelStaticContentModule) },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
  { path: 'csr', loadChildren: () => import('./csr/csr.module').then(m => m.CsrModule) },
  { path: 'accounting', loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule) },
  { path: 'documents', loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule) },
  { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
  { path: 'bookings', loadChildren: () => import('./bookings/bookings.module').then(m => m.BookingsModule) },
  { path: 'quotes', loadChildren: () => import('./quotes/quotes.module').then(m => m.QuotesModule) },
  { path: 'genai', loadChildren: () => import('./genai/genai.module').then(m => m.GenaiModule) },
  { path: 'visa', loadChildren: () => import('./visa/visa.module').then(m => m.VisaModule) },
  { path: 'flights', loadChildren: () => import('./flights/flights.module').then(m => m.FlightsModule) },
  { path: 'hotels', loadChildren: () => import('./hotels/hotels.module').then(m => m.HotelsModule) },
  { path: 'price-alerts', loadChildren: () => import('./price-alerts/price-alerts.module').then(m => m.PriceAlertsModule) },
  { path: 'wallet', loadChildren: () => import('./wallet/wallet.module').then(m => m.WalletModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
